'use client';

import { useTranslations } from 'next-intl';

import { cn } from '@/lib/utils/cn';
import { T_Pool } from '@/ts/types/T_Pool';

import { TokenDistributionChart } from './TokenDistributionChart';
import { TokenHeader } from './TokenHeader';
import { TokenStats } from './TokenStats';

interface I_TokenInfoProps {
  token: T_Pool;
  className?: string;
}

export function TokenInfo({ token, className = '' }: I_TokenInfoProps) {
  const t = useTranslations('pools');

  const bannerUrl = token.banner?.url || token.bannerMobile?.url || '';
  const bannerAlt =
    token.banner?.alt || token.bannerMobile?.alt || token.tokenName;
  const currentPrice = parseFloat(token?.presaleTokenPriceInUSDC) || 0;

  return (
    <div className={cn('bg-background', className)}>
      <TokenHeader
        bannerUrl={bannerUrl}
        bannerAlt={bannerAlt}
        tokenSymbol={token.tokenSymbol}
        currentPrice={currentPrice}
        color={token.color}
        t={t}
        pool={token}
      />

      <div className="grid grid-cols-2 px-7 py-6 overflow-hidden">
        <TokenStats token={token} t={t} />
        <div className="relative">
          <TokenDistributionChart token={token} />
        </div>
      </div>
    </div>
  );
}
